import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserProvider";

export default function ProtectedRoute({ children }) {
    const { isLoggedIn } = useUser();

    return isLoggedIn === true ? children : <Navigate to="/login" />;
}
